import logger, { CONTEXTS } from 'modules/Logger';
import SearchContainer from './primitives/SearchContainer';
import SearchContent from './primitives/SearchContent';
import SearchContext from 'contexts/Search/SearchContext';
import withAnalytics from 'modules/Analytics/withAnalytics';
import withCancel from 'utils/withCancel';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  getAnalyticsData,
  getFilterTypeHandler,
  getTopHit,
  newOnShowMoreClickHandler,
  newSearchHandler,
  onKeyDownHandler,
  onPropsChangeHandler,
  renderNewSearch,
  setTrackingDataHandler,
  trackSearchEventHandler,
} from './lib';
import { localize } from 'redux-i18n';
import { mapStateToProps } from './lib/mapStateToProps';
import { navigate } from 'state/Routing/actions';
import { PureComponent } from 'react';
import { setSearchQueryId } from 'state/SearchNew/actions';

// BIG ASS TODO: Separate out to an abstract react-autocomplete or some shit
// ANOTHER BIG ASS TODO: Refactor this to a functional component, move search logic to thunk, and extract search results to own component.
class Search extends PureComponent {
  static propTypes = {
    country: PropTypes.string.isRequired,
    searchFilter: PropTypes.string,
    searchQuery: PropTypes.string.isRequired,
  };

  state = {
    exitType: 'cancel',
    offset: 0,
    result: {},
    resultCount: 0,
    selected: 0,
    showMoreVisible: false,
  };

  /* imported methods */

  getFilterType = getFilterTypeHandler(this);

  onKeyDown = onKeyDownHandler(this);

  search = newSearchHandler(this);

  onShowMoreClick = newOnShowMoreClickHandler(this);

  onPropsChange = onPropsChangeHandler(this);

  setTrackingData = setTrackingDataHandler(this);

  trackSearchEvent = trackSearchEventHandler(this);

  /* end imported methods */

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
    this.asyncData = withCancel(this.onPropsChange(this.props));
    this.asyncData
      .then(({ result }) => {
        return getTopHit(result.bestMatch);
      })
      .then(topHit => {
        this.setState({ topHit });
      })
      .catch(e => {
        const errObj = e instanceof Error ? e : new Error(e);
        logger.error([CONTEXTS.SEARCH], errObj.message, {}, errObj);
      });

    const { country, searchQuery } = this.props;

    if (searchQuery.length > 0) {
      this.search(country).then(results =>
        this.setState({
          result: results.result,
          queryId: results.queryId,
          resultCount: results.resultCount,
        }),
      );
    }
  }

  componentDidUpdate({ searchFilter, searchQuery }) {
    const queryDidUpdate =
      searchFilter !== this.props.searchFilter ||
      searchQuery !== this.props.searchQuery;

    if (queryDidUpdate) {
      this.onPropsChange(this.props)
        .then(async ({ result, ...rest }) => {
          let topHit;
          if (!this.props.searchFilter) {
            topHit = await getTopHit(result.bestMatch);
          }

          this.setState(state => ({
            ...rest,
            result,
            topHit: topHit ?? state.topHit,
          }));
        })
        .catch(e => {
          const errObj = e instanceof Error ? e : new Error(e);
          logger.error([CONTEXTS.SEARCH], errObj.message, {}, errObj);
        });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
    if (document.activeElement) document.activeElement.blur();

    this.trackSearchEvent();
    this.asyncData.cancel();
  }

  render() {
    const { hidePlayer, modal: Modal, searchFilter } = this.props;
    const filterType = this.getFilterType(searchFilter);

    const { searchSections, showMoreVisible, showMoreBtn } = renderNewSearch(
      this.props,
      this.state,
      filterType,
      this.setTrackingData,
      this.onShowMoreClick,
    );

    return (
      <Modal>
        <SearchContext.Provider value={this.NEW_SEARCH}>
          <SearchContainer hidePlayer={hidePlayer}>
            <SearchContent data-test="search-content" id="search-content">
              {searchSections}
              {showMoreVisible ? showMoreBtn : null}
            </SearchContent>
          </SearchContainer>
        </SearchContext.Provider>
      </Modal>
    );
  }
}

export default compose(
  localize('translate'),
  connect(mapStateToProps, { navigate, setSearchQueryId }),
  withAnalytics(getAnalyticsData, {
    trackOnDidUpdate: (prevProps, nextProps) =>
      prevProps.searchFilter !== nextProps.searchFilter,
  }),
)(Search);
